import * as msal from "@azure/msal-browser";
 
const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_CLIENT_APP_ID,
    authority: 'https://login.microsoftonline.com/' + process.env.VUE_APP_TENANT_ID,
    redirectUri: process.env.VUE_APP_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

const loginRequest = {
  scopes: ["User.Read"],
};
 

export const msalInstance = new msal.PublicClientApplication(msalConfig);


const initialize = async () => {
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      let accountResponse=msalInstance.getAccount();
      window.localStorage.setItem('apiAccessToken', accountResponse.username);
      msalInstance.setActiveAccount(response.account);
    }
  }).catch((error) => {
    console.error(error);
  });
};

export const acquireToken = async () => {
  try {
    const response = await msalInstance.acquireTokenSilent(loginRequest);
    window.localStorage.setItem('apiAccessToken', response.accessToken);
    return response.accessToken;
  } catch (error) {
    if (error instanceof msal.InteractionRequiredAuthError) {
      return msalInstance.acquireTokenRedirect(loginRequest);
    } else {
      console.error(error);
    }
  }
};


export const login = async () => {
  try {
    const loginResponse = await msalInstance.handleRedirectPromise();
    const getAccountDetails = msalInstance.getActiveAccount();
    if (!loginResponse) {
      await msalInstance.loginRedirect({
        scopes: ['user.read'],
      });
    } else {
      return loginResponse.account;
    }
  } catch (error) {
    console.error(error);
  }
};
 
export const getEmailDomain = (account) => {
  const username = account.username.toLowerCase();
  return username.split('@')[1];
};